export const Logo = ({ chip = false, height = 40, className = "" }) => {
  const img = (
    <img
      src="/clydeside-logo.png"
      alt="Clyde Side Events"
      data-testid="brand-logo"
      style={{ height }}
      className="w-auto object-contain block"
    />
  );
  if (chip)
    return (
      <div className={`bg-white rounded-xl px-3 py-2 shadow-lg inline-flex items-center ${className}`}>
        {img}
      </div>
    );
  return <div className={`inline-flex items-center ${className}`}>{img}</div>;
};

export default Logo;
